<template>
    <div class="setup-container">
        <div class="header-search">
            <button class="setup-btn" @click="showModal=true">
                <Plus class="icon" />
                <p style="padding: 0%; margin: 0%;">Make Payment</p>
            </button>
            <div class="search-bar">
                <Search />
                <input type="text" placeholder="Search..." v-model="searchQuery" />
            </div>
        </div>
     
    </div>
    <div
        v-if="showModal"
        class="modal fade show"
        style="display: block; background: rgba(0, 0, 0, 0.6);"
        @click.self="closeModal"
        >
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content rounded-3 shadow-lg border-0">
            <!-- Header -->
            <div class="modal-header bg-primary text-white rounded-top">
              <h5 class="modal-title fw-bold">
                <i class="fa fa-id-card me-2"></i> Payment Option
              </h5>
              <button type="button" class="btn-close btn-close-white" @click="closeModal"></button>
            </div>

            <!-- Body -->
            <div class="modal-body p-4">
              <div>
                <!-- Applicant Information -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                  Payment Option
                </h6>
                <div class="row g-3 mb-4">
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Option</label>
                    <select name="" id="">
                        <option value="">-select-</option>
                        <option value="annual-subscription">Annual Subscription</option>
                        <option value="levy">Levy</option>
                    </select>
                  </div>
                  
                </div>

               
              </div>
            </div>

            <!-- Footer -->
            <div class="modal-footer bg-light d-flex justify-content-end gap-2">
              <button class="btn btn-secondary" @click="closeModal">
                <i class="fa fa-times me-1"></i> Close
              </button>
            </div>
          </div>
        </div>
    </div>

</template>

<script setup>
/* eslint-disable */ 

import { ArrowUpRight, ChevronLeft, ChevronRight, PenLine, Search, Trash } from "lucide-vue-next";
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import axios from 'axios';
import PaystackPop from '@paystack/inline-js';

const dataList = ref([]);
const dataFee = ref([])
const showModal = ref(false);
const showEditModal = ref(false);
const selectedItem = ref(null);
let base_url = process.env.VUE_APP_BASE_LIVE_URL
//let base_url = "http://localhost:8888/lltc_backend/"

// Pagination state
const currentPage = ref(1);
const pageSize = 8;
const username = ref(localStorage.getItem('username'));

onMounted( async () => {
  await listRecords();
  await getMembershipFees();
});

onBeforeUnmount( async () => {
  
});

// Computed values
const totalPages = computed(() =>
    Math.ceil(dataList.value.length / pageSize)
);

const parsedGameInterest = computed(() => {
  try {
    if (selectedItem.value && selectedItem.value.game_interest) {
      const interest = selectedItem.value.game_interest;
      return Array.isArray(interest)
        ? interest
        : JSON.parse(interest);
    }
    return [];
  } catch (err) {
    return [];
  }
});

const parsedChildren = computed(() => {
    try {
    if (selectedItem.value && selectedItem.value.children) {
      const child = selectedItem.value.children;
      return Array.isArray(child)
        ? child
        : JSON.parse(child);
    }
    return [];
  } catch (err) {
    return [];
  }
});

const paginatedData = computed(() => {
    const start = (currentPage.value - 1) * pageSize;
    return dataList.value.slice(start, start + pageSize);
});

// Pagination methods
function goToPage(page) {
    if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
    }
}

function prevPage() {
    if (currentPage.value > 1) {
        currentPage.value--;
    }
}

function nextPage() {
    if (currentPage.value < totalPages.value) {
        currentPage.value++;
    }
}

// Action methods

const makePayment = (data) => {
        const paystack = new PaystackPop();

        paystack.newTransaction({
            key: process.env.VUE_APP_PAYSTACK_DEMO_KEY,
            email: data.email,
            amount: parseFloat(dataFee.value.amount) * 100,

            onSuccess: (transaction) => { 
                // Payment complete! Reference: transaction.reference 
               const payment_ref = transaction.reference 
               createPayment(data, payment_ref)
            },
            onCancel: () => {
                // user closed popup
            }
        });
}
const addChild = () =>{
    if (!selectedItem.value.children) {
      selectedItem.value.children = [];
    }
    selectedItem.value.children.push({
      name: '',
      sex: '',
      dob: ''
    });
  }
  
  const removeChild = (index)=> {
    selectedItem.value.children.splice(index, 1);
  }
  
 const handleFileUpload = (event, fieldName) => {
    const file = event.target.files[0];
    if (file) {
      // Handle file upload logic here
      // You might want to upload to server and update the selectedItem
      console.log(`Uploading ${fieldName}:`, file.name);
      
      // For demonstration, just update the filename
      // In a real app, you'd upload and get the new path
      selectedItem.value[fieldName] = file.name;
    }
  }

const listRecords = async () => {
  try {
    const response = await axios.post('/list_myapplications.php', { username: username.value });
    if (response.data.status) dataList.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const getMembershipFees = async () => {
  try {
    const response = await axios.get('/membership_fees.php', { });
    if (response.data.status) dataFee.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const createPayment = async (data, reference) => {
  try {
    const response = await axios.post('/update_payment.php', { user_id: data.email, amount: dataFee.value.amount, email: data.email, description: reference });
    if (response.data.status) {
      alert(response.data.message) 
      window.location.reload();
    }
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

function viewItem(data) {
    //console.log(data)
    selectedItem.value = data;
    showModal.value = true;
}
function editItem(data) {
    console.log(data)
    selectedItem.value = data;
    showEditModal.value = true;
}
function closeModal() {
  showModal.value = false;
}
function closeEditModal() {
  showEditModal.value = false;
}
const updateData = async()=>{
    // Your logic to save the updated data
    console.log('Updating data:', selectedItem.value);
    try {
    const response = await axios.post("/update_application.php", {
      form_data: selectedItem.value,
      headers: { "Content-Type": "multipart/form-data" }
    });

    alert("✅ " + response.data.message);
    
     // Close modal after saving
     closeEditModal();

  } catch (error) {
    console.error(error);
    alert(error.response ? error.response.data.message : error.message);
  }
   
}
function approveItem(item) {
  // You can trigger an API call here to approve the record
  showModal.value = false;
}
const payment = (item) => {
  if (confirm("You will be redirected to our payment page... " + item.firstname + "?")) {
        // do nothing
    }
}
function deleteItem(dataList) {
    if (confirm("Delete " + dataList.name + "?")) {
        dataList.value = dataList.value.filter((i) => i.id !== dataList.id);
    }
}
</script>

<style lang="scss" scoped>

.modal-content {
  border-radius: 12px;
  overflow-y: auto;
  max-height: 750px;
}
.btn-secondary{
    width: 80px !important;
}
.btn-success{
    width: 100px !important;
}
.modal-header {
  padding: 1rem 1.5rem;
}

.modal-body label {
  font-size: 0.85rem;
}

.modal-body p {
  font-size: 0.95rem;
}

.badge {
  font-size: 0.85rem;
  padding: 0.5em 0.8em;
  border-radius: 6px;
}

.setup-container {
    min-height: 100vh;
    padding: 24px;

}
.application-title{
    text-align: left;
}
/* Header: Setup button + search bar */
.header-search {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    width: 100%;
    margin-bottom: 16px;
}

/* Search bar */
.search-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #CED4DA;
    border-radius: 8px;
    padding: 8px 12px;
    flex: 1 1 200px;
    /* allows shrinking */
    max-width: 350px;
}

.search-bar input {
    border: none;
    outline: none;
    width: 100%;
    font-size: 16px;
}

/* Table styles */
.table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 16px;
    border-radius: 8px;
    overflow-x: auto;
}

.table thead {
    display: table-header-group;
}

.table tbody {
    display: table-row-group;
}

.table th,
.table td {
    border: 1px solid #E9ECEF;
    border-radius: 8px;
    box-shadow: #6C757D33 0px 1px 3px 0px, #6C757D1A 0px 1px 2px 0px;
    padding: 12px 16px;
    text-align: left;
    font-size: 14px;
}

.table th {
    background: #fff;
    color: #6C757D;
}

.actions {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
}

.setup-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background-color: #fff;
    color: #DB6813;
    border: 1px solid #DB6813;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
}

/* Buttons */
.btn {
    width: 36px;
    height: 36px;
    border: 1px solid #CED4DA;
    border-radius: 8px;
    color: #343A40;
    background: white;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
}

.btn:hover {
    border: 1px solid #0DCAF0;
    color: #0DCAF0;
}

.btn .icon {
    width: 18px;
    height: 18px;
}

/* Pagination */
.pagination {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 12px;
}

.pagination button {
    width: 36px;
    height: 36px;
    border: 1px solid #CED4DA;
    border-radius: 8px;
    color: #343A40;
    background: white;
    cursor: pointer;
}

.pagination button.active {
    border: 1px solid #0057FC;
    color: #0057FC;
}

.pagination button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #E9ECEF;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
    .setup-container {
        padding: 12px;
    }

    .table th,
    .table td {
        padding: 8px 10px;
        font-size: 12px;
    }

    .search-bar {
        flex: 1 1 100%;
        margin-top: 8px;
    }

    .setup-btn {
        padding: 6px 10px;
        font-size: 12px;
    }

    .btn {
        width: 32px;
        height: 32px;
    }

    .btn .icon {
        width: 16px;
        height: 16px;
    }

    .pagination button {
        width: 32px;
        height: 32px;
        font-size: 12px;
    }

    /* Make table scrollable on mobile */
    .table {
        display: block;
        overflow-x: auto;
        white-space: nowrap;
    }
}
</style>
